/**
 * Fixed date and time patterns, for the API, keys and file names. They are read and written by DateHelper, with the
 * letters of Unicode, Angular and .NET: `yyyy` year, `MM` month, `dd` day, `HH` hour, `mm` minute, `ss` second,
 * `SSS` milliseconds, `xxx` offset as `+02:00`, text between single quotes as it is.
 * Dates shown to the user do not use these patterns: they go through LocaleService and the `localDate` pipe.
 */
export class DateTimeFormats {
  public static DATETIME_FORMAT = "yyyy-MM-dd HH:mm:ss";
  public static DATETIME_FORMAT_SHORT = "dd-MM-yyyy HH:mm:ss";
  public static DATETIME_FORMAT_SHORT_SLASH = "dd/MM/yyyy HH:mm:ss";
  public static DATETIME_FORMAT_SHORT_SLASH_NO_SECONDS = "dd/MM/yyyy HH:mm";
  public static DATETIME_FORMAT_SHORT_SLASH_NO_SECONDS_COMA = "dd/MM/yyyy, HH:mm";
  public static DATETIME_FORMAT_SHORT_YEAR = "yyyy";
  public static DATETIME_FORMAT_SHORT_MONTH_YEAR = "MM yyyy";
  public static DATETIME_FORMAT_SHORT_DATE_SLASH = " dd/MM";
  public static DATETIME_FORMAT_SHORT_DATE_STRAIGHT = "dd-MM-yyyy";
  public static DATETIME_FORMAT_SHORT_DATE_INVERSE = "yyyy-MM-dd";
  public static DATETIME_FORMAT_LONG_HOUR_MINUTE_SECONDS = "HH:mm:ss";
  public static DATETIME_FORMAT_LONG_HOUR_MINUTE_SECONDS_MILLISECOND = "HH:mm:ss.SSS";
  public static DATETIME_FORMAT_LONG_HOUR_MINUTES = "HH:mm";
  public static DATETIME_FORMAT_DATE_YEAR = "dd/MM/yyyy";
  public static DATETIME_FORMAT_SHORT_DATE_YEAR = "dd/MM/yy";
  public static DATETIME_FORMAT_DEVICE_VALID_LIST = "yyyy-MM-dd'T'HH:mm:ss";
  public static DATETIME_API_IT_CULTURE_INFO = "dd/MM/yyyy HH:mm:ss";
  /** Local time followed by a literal `Z`, the format the API has always received in these fields. */
  public static DATETIME_FORMAT_ISO = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
  public static DATETIME_FORMAT_ISO_UTC_SIMPLE = "yyyy-MM-dd'T'HH:mm:ssxxx";
  /** Date and time with the offset, as the date pickers emit them: `2026-10-14T10:30:00+02:00`. */
  public static DATETIME_FORMAT_ISO_UTC_WITH_TZD = "yyyy-MM-dd'T'HH:mm:ssxxx";
}
